import React from 'react';
import styles from './MediaType.scss';
import { Text } from '../../../../components/common';
import { FormattedMessage } from 'react-intl';
import { IOuter } from './MediaTypes.types';

export const MediaTypeComponent: React.FC<IOuter> = ({ settings }) => {
  const imageStyles = {
    backgroundImage: `url(${settings.image})`,
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.image} style={imageStyles} />

      <Text className={styles.label} weight="bold" size="small">
        <FormattedMessage id={settings.translationKey} />
      </Text>
    </div>
  );
};
